import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import zh from './i18n/zh.json'  // 你的中文语言包
import en from './i18n/en.json'  // 你的英文语言包
import Vuex from 'vuex'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.use(Vuex)

Vue.prototype.$EventBus = new Vue()

// 新增：检测浏览器/设备默认语言
const detectDefaultLanguage = () => {
  // 获取浏览器语言（兼容不同浏览器）
  const browserLang = navigator.language || navigator.userLanguage;
  // 包含 'zh' 则视为中文环境（如 'zh-CN'、'zh-TW' 等），否则默认英文
  return browserLang.includes('zh') ? 'zh' : 'en';
};

const store = new Vuex.Store({
  state: {
    // 初始语言改为自动检测结果（替代原有的 'en'）
    locale: detectDefaultLanguage(),
  },
  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale
      // 同步更新 i18n 实例的语言（如果后续需要手动切换语言）
      i18n.locale = locale;
    },
  },
  getters: {  
    getLocale: state => state.locale,  
  },
})

const i18n = new VueI18n({
  // 从 Vuex 状态获取当前语言（初始值已通过检测设置）
  locale: store.state.locale,
  messages: {
    zh,  // 中文语言包
    en,  // 英文语言包
  },
})

new Vue({
  router,
  store,
  i18n,  // 注册 i18n 实例
  render: h => h(App)
}).$mount('#app')